'use client'

import { Fragment } from 'react'

import { AuthModalType } from '~/utils/hooks/useAuthModal'

import { LoginModal } from '~/components/AuthModals/LoginModal/LoginModalView'
import { RegisterModal } from '~/components/AuthModals/RegisterModal/RegisterModalView'
import CheckYourEmailModal from '~/components/CheckYourEmailModal'
import { Dialog } from '~/components/Dialog'
import ForgotPasswordModal from '~/components/ForgotPasswordModal'
import VerifyAccountModal from '~/components/VerifyAccountModal'

interface AuthModalsViewProps {
  modalType: AuthModalType | null
  setModalType: React.Dispatch<React.SetStateAction<AuthModalType | null>>
}

const AuthModalsView = ({ modalType, setModalType }: AuthModalsViewProps) => {
  const handleClose = () => setModalType(null)

  const renderModalContent = () => {
    switch (modalType) {
      case 'login':
        return (
          <LoginModal
            handleClose={handleClose}
            onLogin={handleClose}
            onRegisterLinkClick={() => setModalType('register')}
            onForgotPasswordClick={() => setModalType('reminder')}
          />
        )
      case 'register':
        return (
          <RegisterModal
            handleClose={handleClose}
            onLoginLinkClick={() => setModalType('login')}
            onSuccess={(user, social) => (social ? setModalType(null) : setModalType('verifyaccount'))}
          />
        )
      case 'reminder':
        return <ForgotPasswordModal onSuccess={() => setModalType('checkyouremail')} />
      case 'checkyouremail':
        return <CheckYourEmailModal handleClose={handleClose} />
      case 'verifyaccount':
        return <VerifyAccountModal handleClose={handleClose} />
      default:
        return null
    }
  }

  return (
    <Fragment>
      <Dialog
        dialogContext={{
          open: modalType !== null,
          onOpenChange: () => setModalType(null),
          'open.controlled': true,
          id: 'auth-dialog',
        }}>
        {renderModalContent()}
      </Dialog>
    </Fragment>
  )
}

export default AuthModalsView
